import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useState, useRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import roundSend from '@iconify/icons-ic/round-send';
import heartFill from '@iconify/icons-eva/heart-fill';
import shareFill from '@iconify/icons-eva/share-fill';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import messageSquareFill from '@iconify/icons-eva/message-square-fill';
import roundAddPhotoAlternate from '@iconify/icons-ic/round-add-photo-alternate';
// material
import {
  Box,
  Link,
  Card,
  Stack,
  Paper,
  Avatar,
  TextField,
  Typography,
  CardHeader,
  IconButton,
  AvatarGroup,
  InputAdornment,
  FormControlLabel
} from '@material-ui/core';
// utils
import JobNoteWindow from '../../chat/JobNoteWindow';

// ----------------------------------------------------------------------

JobNotesMessageBoard.propTypes = {
  post: PropTypes.object
};



export default function JobNotesMessageBoard({ products,acceptedClients,requestDetails,fromDesign,isDesignOrder,renderCards,setRenderCards,fetchRequestDetails,details,accessPublicMessageBoard ,requestId}) {
  let user = JSON.parse(localStorage.getItem('user'))
  const userType=user.user_type
  const userId=user.user_id
console.log('acceptedClientsss',acceptedClients)
console.log('requestiddd 1',requestId)
console.log('details in JobNotesMessageBoard:', details)
console.log('design_order_id:', details?.design_order_id)
  return (
   
    <Card sx={{ height: '72vh', display: 'flex' }}>
    <JobNoteWindow products={products} requestIdd={requestId} designOrderId={details?.design_order_id || null} isDesignOrder={isDesignOrder} requestDetails={requestDetails} allUser={acceptedClients} fromDesign={fromDesign} setRenderCards={setRenderCards} renderCards={renderCards} fetchRequestDetails={fetchRequestDetails}  details={details} accessPublicMessageBoard={accessPublicMessageBoard}/>
  </Card>
    //

  );
}
